#import "../fragments/notification-fragment.graphql"

query GetNotifications {
    notifications {
        ...NotificationFragment
    }
}
